import BaseApiService from './base-api-service';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default class PowerService extends BaseApiService {
  public async getPower(): Promise<any> {
    const response = await this.getResource('/GetPower/Daily_Market_Total');

    return response;
  }
}
